import React, { useRef } from 'react';
import { Select } from 'antd';
import PropTypes from 'prop-types';
import CaracteristicaLenteCard from '../dataDisplay/CaracteristicaLenteCard';

const { Option } = Select;

export default function CaracteristicaLenteSelectCard({
  caracteristica, backgroundImage, onSelect, valorSeleccionado,
}) {
  const { opciones, nombre: nombreCaracteristica } = caracteristica;
  const selectRef = useRef(null);
  let estaSeleccionada = false;

  const optionsJSX = opciones.map(({ valor, nombre }) => {
    const key = `caracteristicalenteselectcard_option_${valor}`;
    return <Option key={key} value={valor}>{nombre}</Option>;
  });

  let opcionSeleccionada = null;
  const opcionSeleccionadaObj = opciones.find(({ valor }) => valor === valorSeleccionado);
  let imagenDeFondo = backgroundImage;

  if (opcionSeleccionadaObj) {
    const { valor, foto } = opcionSeleccionadaObj;
    opcionSeleccionada = valor;
    estaSeleccionada = true;
    imagenDeFondo = foto;
  } else {
    opcionSeleccionada = undefined;
  }

  function handleOnClick(event) {
    selectRef.current.rcSelect.setOpenState(true);
    if (event !== undefined) {
      const opcionSeleccionada = opciones.find(({ valor }) => valor === event);
      onSelect(opcionSeleccionada);
    }
  }

  return (
    <CaracteristicaLenteCard
      estaSeleccionada={estaSeleccionada}
      handleOnClick={() => handleOnClick()}
      backgroundImage={imagenDeFondo}
    >
      <Select
        value={opcionSeleccionada}
        ref={selectRef}
        onSelect={item => handleOnClick(item)}
        showSearch
        style={{ width: '100%', display: 'block' }}
        placeholder={`Seleccione ${nombreCaracteristica}`}
        showAction={['click']}
      >
        { optionsJSX }
      </Select>
    </CaracteristicaLenteCard>
  );
}
CaracteristicaLenteSelectCard.propTypes = {
  opciones: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    label: PropTypes.string,
  })),
  onSelect: PropTypes.func,
};
CaracteristicaLenteSelectCard.defaultProps = {
  opciones: [],
  onSelect: () => {},
};
